"use strict";

(function () {
  'use strict';

  angular.module('auth-service', []).constant('AUTH_EVENTS', {
    channel: 'AUTH_CHANNEL',
    loggedIn: 'logged-in',
    loggedOut: 'logged-out',
    requiresLogin: 'requires-login'
  }).factory('AuthService', AuthService);
  AuthService.$inject = ['$window', 'localStorageService', 'MessageController', 'AUTH_EVENTS'];

  function AuthService($window, localStorageService, MessageController, AUTH_EVENTS) {
    var Auth = {};
    var _keyName = 'at';

    Auth.saveToken = function (token) {
      try {
        //if (token && Math.round(new Date().getTime() / 1000) <= _parseJwt(token).exp) {
        if (token && _parseJwt(token).hasOwnProperty('userId')) {
          localStorageService.set(_keyName, token);
        }
      } catch (error) {
        console.log(error);
      }
    };

    Auth.getToken = function () {
      return localStorageService.get(_keyName);
    };

    Auth.getUser = function () {
      var token = Auth.getToken();

      if (token) {
        return _parseJwt(token);
      } else {
        return null;
      }
    };

    Auth.isLoggedIn = function () {
      var token = Auth.getToken();

      if (token) {
        var params = _parseJwt(token);

        if (params && params.hasOwnProperty('userId')) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    };

    Auth.isValidToken = function (token) {
      var pattern = new RegExp('^[A-Za-z0-9-_=]+.[A-Za-z0-9-_=]+.?[A-Za-z0-9-_.+/=]*$');
      return pattern.test(token);
    };

    function _parseJwt(token) {
      try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse($window.atob(base64));
      } catch (error) {
        return null;
      }
    }

    Auth.logout = function () {
      localStorageService.remove(_keyName);
      MessageController.publish(AUTH_EVENTS.channel, AUTH_EVENTS.loggedOut);
    };

    return Auth;
  }
})();